import { BookOutlined, LaunchOutlined } from '@mui/icons-material'
import { Tooltip, Typography } from '@mui/material'
import { HTMLAttributes, ReactNode } from 'react'
import { navItemStyle } from 'src/features/globalNavigation/components/navItem/navItemStyle'

type NavItemExternalLinkProps = {
  /**
   * 外部リンク
   * e.g. `https://example.com/help-page`
   */
  externalPath: string
  isBeta?: boolean
  /**
   * 折り畳まれているかどうか
   */
  isCollapsed: boolean
  icon?: ReactNode
  title: string
} & HTMLAttributes<HTMLElement>

/**
 * グローバルナビゲーションの個々のアイテム (外部リンク)
 */
export const NavItemExternalLink: React.FC<NavItemExternalLinkProps> = (
  props: NavItemExternalLinkProps,
) => {
  const {
    externalPath,
    isCollapsed,
    title,
    icon,
    isBeta = false,
    ...restProps
  } = props

  // 開閉状態に応じて表示内容を切り替える
  let content: ReactNode
  if (isCollapsed) {
    content = icon ? (
      icon
    ) : (
      <BookOutlined fontSize="small" sx={{ width: '20px', height: '20px' }} />
    )
  } else {
    content = (
      <>
        {icon && icon}
        <Typography variant="subtitle2">
          {title}
          {isBeta && ' (β版)'}
        </Typography>
        {!icon && (
          <LaunchOutlined
            fontSize="small"
            sx={{ width: '20px', height: '20px' }}
          />
        )}
      </>
    )
  }

  return (
    <Tooltip title={isCollapsed ? title : ''} placement="right" arrow>
      <a
        {...restProps}
        css={[
          navItemStyle.container,
          isCollapsed && navItemStyle.containerCollapsed,
        ]}
        href={externalPath}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={title}
      >
        {content}
      </a>
    </Tooltip>
  )
}
